import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import PointsPage from '@/organizations/_default/points'
import Page from '@/services/Page'

import PointsAreaFilter from './components/PointsAreaFilter.vue'
import functions from './utils/functions.ts'

export default defineComponent({
  extends: PointsPage,
  components: {
    PointsAreaFilter
  },
  setup(props, context) {
    const page = PointsPage.setup(props, context)
    const store = useStore()

    store.dispatch('setOrganizationActions', functions)

    return {
      ...page,
      Page
    }
  }
})
